import {generalRequest} from "@/lib/services/requests";
import {useQuery} from "@tanstack/react-query";

export const useApiSearchTeacherTimes = (args, config) => {
    return useQuery({
        queryKey: ['teacher', 'times', 'search', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/teacher/times`, {params: config})
        })(args)),
    })
}

